import api from "../../../app/api";
import {BundleType} from "./BundlesList";

export interface Bundle {
  id: number;
  name: string;
  type: BundleType;
  price: number;
  status: string;
  user_limit: number;
  waiver_limit: number;
  storage_limit: number;
  submit_limit: number;
  location_limit: number;
  created_at: string;
  created_by: number;
  deleted_at: string | null;
  deleted_by: number | null;
}
export async function loadBundles(type: string) {
  return api.get<{ success: boolean; data: Bundle[]; message: string }>(
    `/bundles/index?type=${type}`,
  );
}